import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, useFragment } from 'react-relay';
import { Link } from 'dibs-elements/exports/Link';

import Gallery from 'dibs-icons/exports/legacy/Gallery';
import { SharedContactDealerWrapper } from '../../../../contactDealer/SharedContactDealerWrapper';

import { RequestMoreImages_user$key } from './__generated__/RequestMoreImages_user.graphql';
import { RequestMoreImages_item$key } from './__generated__/RequestMoreImages_item.graphql';

// styles
import styles from './RequestMoreImages.scss';

const itemFragment = graphql`
    fragment RequestMoreImages_item on Item {
        ...SharedContactDealerWrapper_item
    }
`;

const userFragment = graphql`
    fragment RequestMoreImages_user on User {
        ...SharedContactDealerWrapper_user
    }
`;

const ContactSellerLink: FC<{ onClick?: () => void }> = ({ onClick = () => {} }) => (
    <Link className={styles.link} onClick={onClick}>
        <FormattedMessage id="RequestMoreImages.contactSeller" defaultMessage="Contact Seller" />
    </Link>
);

export const RequestMoreImages: FC<{
    user: RequestMoreImages_user$key | null;
    item: RequestMoreImages_item$key;
    disableRequestMoreImagesModal?: boolean;
    currency: string;
}> = ({ user: userRef, item: itemRef, disableRequestMoreImagesModal = false, currency }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);

    return (
        <div className={styles.container}>
            <Gallery className={styles.icon} />
            <div className={styles.header}>
                <FormattedMessage
                    id="RequestMoreImages.requestMoreMediaHeader"
                    defaultMessage="Want more images or videos?"
                />
            </div>
            <div className={styles.subheader}>
                <FormattedMessage
                    id="RequestMoreImages.requestMoreMediaSubheader"
                    defaultMessage="Request additional images or videos from the seller"
                />
            </div>
            {disableRequestMoreImagesModal ? (
                <ContactSellerLink />
            ) : (
                <SharedContactDealerWrapper
                    item={item}
                    user={user}
                    launchOrigin="pdp image carousel"
                    modalType="REQUEST_IMAGES"
                    currency={currency}
                >
                    {(onClick: $TSFixMe) => <ContactSellerLink onClick={onClick} />}
                </SharedContactDealerWrapper>
            )}
        </div>
    );
};
